const developEndpoints = {
    orgUrl: "http://localhost:8000",
    eventsUrl: "http://localhost:8000",
    usersBaseUrl: "http://localhost:8000",
    resUrl: "http://localhost:8000",
    paymentUrl: "http://localhost:8000",
    coreUrl: "http://localhost:8000"
}

const productionEndpoints = {
 orgUrl : "https://tslit6m8be.execute-api.us-east-1.amazonaws.com/v1",
 resUrl : "https://tslit6m8be.execute-api.us-east-1.amazonaws.com/v1",
 eventsUrl : "https://12yym0aore.execute-api.us-east-1.amazonaws.com/v1",
 usersBaseUrl : "https://5uxpq2lbbk.execute-api.us-east-1.amazonaws.com/v1",
 webAppUrl : "https://callvita-cloud.com/clinic_signup?m=1",
 paymentUrl : "https://ryb85uym9k.execute-api.us-east-1.amazonaws.com/v1",
 coreUrl : "https://y4mfifdfoe.execute-api.us-east-1.amazonaws.com/v1",

}

export const endpoints = process.env.REACT_APP_STAGE === 'develop' ? developEndpoints : productionEndpoints;